"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2534],{

/***/ 17287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FileRelatedButtons_EditButton; },
  "v": function() { return /* binding */ openEditModalIdAtom; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/vanilla.mjs
var vanilla = __webpack_require__(65058);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var esm_react = __webpack_require__(752);
// EXTERNAL MODULE: ./components/User/_components/common/ProPlanUpgradeModal/index.tsx + 22 modules
var ProPlanUpgradeModal = __webpack_require__(8898);
// EXTERNAL MODULE: ./state/file/uploadingfile.atom.ts
var uploadingfile_atom = __webpack_require__(19718);
// EXTERNAL MODULE: ./components/User/_components/pdf/FileRelatedButtons/index.styles.ts
var index_styles = __webpack_require__(24430);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(29941);
// EXTERNAL MODULE: ./components/User/_components/common/CreateFileModal/FileUpload/Preview/index.tsx + 1 modules
var Preview = __webpack_require__(98538);
// EXTERNAL MODULE: ./components/User/_components/common/Loading/index.tsx + 2 modules
var Loading = __webpack_require__(30541);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/EditFileModal/index.styles.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var GrayBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Stack */.Kq,  true ? {
  target: "e16ubr9h1"
} : 0)( true ? {
  name: "arfe1i",
  styles: "border-radius:8px"
} : 0);
var LoadingWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e16ubr9h0"
} : 0)("position:absolute;z-index:", zIndex/* Z_INDEX.loadingWrapper */.k.loadingWrapper, ";top:0;right:0;bottom:0;left:0;background:rgb(255 255 255 / 75%);" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/EditFileModal/ThumbnailButton/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewowyhc1"
} : 0)( true ? {
  name: "1edddf7",
  styles: "position:relative;overflow:hidden;width:530px;height:289px;&:hover{cursor:pointer;}"
} : 0);
var Overlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "ewowyhc0"
} : 0)( true ? {
  name: "1n980um",
  styles: "position:absolute;top:0;right:0;bottom:0;left:0;background-color:rgb(79 88 96 / 50%)"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/EditFileModal/ThumbnailButton/index.tsx






var ThumbnailButton = function ThumbnailButton(_ref) {
  var fileThumbnail = _ref.fileThumbnail,
      handleFileThumbnailClick = _ref.handleFileThumbnailClick,
      isDragActive = _ref.isDragActive;

  var handleThumbButtonClick = function handleThumbButtonClick(e) {
    e.stopPropagation();
    handleFileThumbnailClick();
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    onClick: handleThumbButtonClick,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
      src: fileThumbnail,
      layout: "fill",
      objectFit: "cover"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overlay, {
      alignItems: "center",
      justifyContent: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "md-medium",
        color: "white",
        textAlign: "center",
        children: isDragActive ? '여기에 놓아 업로드하세요.' : '클릭 또는 파일을 드래그하여 업로드하세요.'
      })
    })]
  });
};

/* harmony default export */ var EditFileModal_ThumbnailButton = (ThumbnailButton);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/mutations/file/useEditFile.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var editFile = function editFile(request) {
  return api/* api.put */.h.put('/v2/file', request, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

var useEditFile = function useEditFile(options) {
  return (0,useMutation/* useMutation */.D)(editFile, _objectSpread({}, options));
};

/* harmony default export */ var file_useEditFile = (useEditFile);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/EditFileModal/useHandleEditFile.tsx







var useHandleEditFile = function useHandleEditFile(_ref) {
  var fileId = _ref.fileId,
      handleEditModalClose = _ref.handleEditModalClose;
  var router = (0,next_router.useRouter)();
  var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
  var fileUploadRef = (0,react.useRef)(null);
  var setIsTriggerUploadingRequest = (0,esm_react/* useSetAtom */.b9)(uploadingfile_atom/* isTriggerUploadingRequestAtom */._M);

  var _useState = (0,react.useState)(undefined),
      file = _useState[0],
      setFile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isFileChange = _useState3[0],
      setIsFileChange = _useState3[1];

  var _useEditFile = file_useEditFile({
    onSuccess: function onSuccess() {
      setIsLoading(false);
      handleEditModalClose();

      if (isFileChange) {
        router.replace('/user/pdf');
      }

      setIsTriggerUploadingRequest(true);
      queryClient.invalidateQueries({
        queryKey: ['getFileList']
      });
    }
  }),
      editFile = _useEditFile.mutate;

  var handleFileUploadClick = function handleFileUploadClick() {
    if (fileUploadRef.current) {
      fileUploadRef.current.click();
    }
  };

  var handleFileChange = function handleFileChange(e) {
    if (e.target.files) {
      var _e$target$files;

      setFile((_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0]);
      setIsFileChange(true);
    }
  };

  var getFileFormData = function getFileFormData(_ref2) {
    var fileName = _ref2.fileName,
        isFileChange = _ref2.isFileChange;
    var formData = new FormData();

    if (isFileChange && file) {
      formData.append('pdf', file);
    }

    formData.append('fileId', String(fileId));

    if (fileName) {
      formData.append('name', fileName);
    }

    formData.append('isFileEdited', String(isFileChange));
    return formData;
  };

  var handleEditButtonClick = function handleEditButtonClick(_ref3) {
    var fileName = _ref3.fileName;
    setIsLoading(true);
    var formData = getFileFormData({
      fileName: fileName,
      isFileChange: isFileChange
    });
    editFile(formData);
  };

  return {
    file: file,
    isLoading: isLoading,
    fileUploadRef: fileUploadRef,
    isFileChange: isFileChange,
    handleFileUploadClick: handleFileUploadClick,
    handleFileChange: handleFileChange,
    handleEditButtonClick: handleEditButtonClick
  };
};

/* harmony default export */ var EditFileModal_useHandleEditFile = (useHandleEditFile);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/EditFileModal/index.tsx


function EditFileModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function EditFileModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? EditFileModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : EditFileModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var EditFileModal = function EditFileModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      fileId = _ref.fileId,
      fileName = _ref.fileName,
      fileThumbnail = _ref.fileThumbnail;

  var handleEditModalClose = function handleEditModalClose() {
    setIsOpen(false);
  };

  var _useHandleEditFile = EditFileModal_useHandleEditFile({
    fileId: fileId,
    handleEditModalClose: handleEditModalClose
  }),
      file = _useHandleEditFile.file,
      fileUploadRef = _useHandleEditFile.fileUploadRef,
      isFileChange = _useHandleEditFile.isFileChange,
      isLoading = _useHandleEditFile.isLoading,
      handleEditButtonClick = _useHandleEditFile.handleEditButtonClick,
      handleFileChange = _useHandleEditFile.handleFileChange,
      handleFileUploadClick = _useHandleEditFile.handleFileUploadClick;

  var _useForm = (0,index_esm/* useForm */.cI)({
    mode: 'onChange',
    defaultValues: {
      fileName: fileName
    }
  }),
      register = _useForm.register,
      getValues = _useForm.getValues,
      setValue = _useForm.setValue,
      _useForm$formState = _useForm.formState,
      errors = _useForm$formState.errors,
      isDirty = _useForm$formState.isDirty,
      isValid = _useForm$formState.isValid,
      trigger = _useForm.trigger;

  var getIsFileChangeValid = function getIsFileChangeValid() {
    return typeof file !== 'undefined' && isDirty ? isValid : true;
  };

  var isEditButtonDisabled = (0,react.useMemo)(function () {
    return isFileChange ? getIsFileChangeValid() : isDirty && isValid;
  }, [isDirty, isValid, isFileChange, file]);

  var onDrop = function onDrop(acceptedFiles) {
    var fakeEvent = {
      target: {
        files: acceptedFiles
      }
    };
    handleFileChange(fakeEvent);
    var uploaded = acceptedFiles[0];

    if (uploaded !== null && uploaded !== void 0 && uploaded.name.endsWith('.pdf')) {
      setValue('fileName', uploaded.name.replace('.pdf', ''));
      trigger();
    }
  };

  var _useDropzone = (0,es/* useDropzone */.uI)({
    onDrop: onDrop,
    accept: {
      'application/pdf': ['.pdf']
    },
    maxFiles: 1,
    multiple: false,
    noClick: true
  }),
      getRootProps = _useDropzone.getRootProps,
      isDragActive = _useDropzone.isDragActive;

  (0,react.useEffect)(function () {
    if (file) {
      setValue('fileName', file.name.replace('.pdf', ''));
      trigger();
    }
  }, [file]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* NoticeModal */.pK, {
    isOpen: isOpen,
    onOpenChange: function onOpenChange(open) {
      return setIsOpen(open);
    },
    title: "\uD30C\uC77C \uC218\uC815\uD558\uAE30",
    buttonType: "success",
    buttonText: "\uC218\uC815\uC644\uB8CC",
    buttonDisabled: !isEditButtonDisabled,
    handleButtonClick: function handleButtonClick() {
      return handleEditButtonClick({
        fileName: getValues('fileName')
      });
    },
    children: [isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingWrapper, {
      justifyContent: "center",
      alignItems: "center",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loading/* default */.Z, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, EditFileModal_objectSpread(EditFileModal_objectSpread({}, getRootProps()), {}, {
      gap: 32,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 16,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "md-semibold",
          children: ["\uC0C8\uB85C\uC6B4 \uD30C\uC77C\uB85C \uAD50\uCCB4\uD558\uAE30", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "sm-semibold",
            color: "cerise_400",
            children: "100MB \uC774\uD558\uC758 \uD30C\uC77C\uB9CC \uC5C5\uB85C\uB4DC \uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4"
          })]
        }), file ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Preview/* default */.Z, {
          file: file,
          filename: file.name,
          onClickChangeFile: handleFileUploadClick
        }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditFileModal_ThumbnailButton, {
          fileThumbnail: fileThumbnail,
          handleFileThumbnailClick: handleFileUploadClick,
          isDragActive: isDragActive
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
          type: "file",
          ref: fileUploadRef,
          width: "100%",
          accept: "application/pdf",
          style: {
            opacity: 0
          },
          onChange: handleFileChange
        })]
      }), file && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GrayBox, {
        gap: 8,
        padding: 16,
        direction: "column",
        backgroundColor: "zinc_50",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "lg-semibold",
          color: "zinc_500",
          children: "\uAE30\uC874 \uD30C\uC77C\uC744 \uAD50\uCCB4\uD558\uBA74"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 6,
          alignItems: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            color: "zinc_500",
            children: "\u2022"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-medium",
            color: "zinc_500",
            children: ["\uC774\uC804 \uD30C\uC77C\uC5D0 \uC124\uC815\uB41C", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
              children: "\uBC84\uD2BC, \uBB38\uC758\uC591\uC2DD, \uBA54\uC2DC\uC9C0 \uBC15\uC2A4, \uB3D9\uC601\uC0C1\uC740 \uC801\uC6A9\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 6,
          alignItems: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            color: "zinc_500",
            children: "\u2022"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-medium",
            color: "zinc_500",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
              children: "\uAE30\uC874\uC758 \uC138\uC77C\uC988\uD074\uB8E8 \uB9C1\uD06C\uAC00 \uC720\uC9C0"
            }), "\uB418\uBA70, \uB9C1\uD06C\uB97C \uD074\uB9AD\uD560 \uC2DC", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
              children: "\uC0C8\uB85C \uAD50\uCCB4\uB41C \uD30C\uC77C\uC774 \uBCF4\uC5EC\uC9D1\uB2C8\uB2E4."
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 6,
          alignItems: "center",
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
            variant: "md-medium",
            color: "zinc_500",
            children: "\u2022"
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-medium",
            color: "zinc_500",
            children: ["\uC774\uC804 \uD30C\uC77C\uC758 \uC5F4\uB78C \uAE30\uB85D\uC740", ' ', (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("b", {
              children: "[\uC5F4\uB78C \uBD84\uC11D] > [\uACE0\uAC1D \uBC18\uC751 \uBD84\uC11D] \uC0C1\uB2E8\uC5D0\uC11C \uD655\uC778\uD558\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
            })]
          })]
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
          gap: 16,
          direction: "column",
          onClick: function onClick(e) {
            return e.stopPropagation();
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "md-semibold",
            children: ["\uD30C\uC77C \uC774\uB984", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
              variant: "sm-semibold",
              color: "zinc_400",
              children: "\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD558\uBA74 \uD574\uB2F9 \uD30C\uC77C\uBA85\uC774 \uC790\uB3D9\uC73C\uB85C \uC785\uB825\uB429\uB2C8\uB2E4."
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Input */.II, EditFileModal_objectSpread({
            width: "100%",
            isError: Boolean(errors.fileName)
          }, register('fileName', {
            required: '이름을 입력해주세요.'
          })))]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* HookFormErrorMessage */.h7, {
          errors: errors,
          name: "fileName"
        })]
      })]
    }))]
  });
};

/* harmony default export */ var EditButton_EditFileModal = (EditFileModal);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/index.tsx











var openEditModalIdAtom = (0,vanilla/* atom */.cn)(null);

var EditButton = function EditButton(_ref) {
  var fileId = _ref.fileId,
      fileName = _ref.fileName,
      fileThumbnail = _ref.fileThumbnail,
      userPlan = _ref.userPlan,
      isDisabled = _ref.isDisabled,
      handleDisabledButtonClick = _ref.handleDisabledButtonClick,
      handleHoverSideAction = _ref.handleHoverSideAction,
      children = _ref.children;
  var toast = (0,src/* useToast */.pm)();
  var notSetCtaFormFileIdList = (0,esm_react/* useAtomValue */.Dv)(uploadingfile_atom/* notSetCtaFormFileIdListAtom */.GE);
  var setOpenEditModalId = (0,esm_react/* useSetAtom */.b9)(openEditModalIdAtom);

  var _useState = (0,react.useState)(false),
      isOpenEditModal = _useState[0],
      setIsOpenEditModal = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isOpenProPlanUpgradeModal = _useState2[0],
      setIsOpenProPlanUpgradeModal = _useState2[1];

  var handleClickEditButton = function handleClickEditButton(e) {
    e.stopPropagation();

    if (isDisabled) {
      handleDisabledButtonClick(e);
      return;
    }

    if (handleHoverSideAction) {
      handleHoverSideAction(false);
    }

    setOpenEditModalId(fileId);

    if (userPlan === 'Free') {
      toast('해당 기능은 Basic 플랜부터 이용할 수 있습니다');
      setIsOpenProPlanUpgradeModal(true);
    } else {
      setIsOpenEditModal(true);
    }
  };

  (0,react.useEffect)(function () {
    if (!isOpenEditModal) {
      setOpenEditModalId(null);
    }
  }, [isOpenEditModal, setOpenEditModalId]);
  var isCtaFormSettingModalOpen = notSetCtaFormFileIdList.length > 0;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [children ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
      className: classnames_default()('', {
        'is-disabled': isDisabled
      }),
      onClick: handleClickEditButton,
      children: children
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles/* GrayBorderButton */.QN, {
      className: classnames_default()('', {
        'is-disabled': isDisabled
      }),
      onClick: handleClickEditButton,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:note-pencil",
        size: 17,
        color: "inherit"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "sm-medium",
        color: "inherit",
        children: "\uC218\uC815"
      })]
    }), !isCtaFormSettingModalOpen && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton_EditFileModal, {
      isOpen: isOpenEditModal,
      setIsOpen: setIsOpenEditModal,
      fileId: fileId,
      fileName: fileName,
      fileThumbnail: fileThumbnail
    }), !isCtaFormSettingModalOpen && isOpenProPlanUpgradeModal && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProPlanUpgradeModal/* default */.Z, {
      onOpenChange: function onOpenChange(open) {
        setIsOpenProPlanUpgradeModal(open);
      }
    })]
  });
};

/* harmony default export */ var FileRelatedButtons_EditButton = (EditButton);

/***/ }),

/***/ 24430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QN": function() { return /* binding */ GrayBorderButton; },
/* harmony export */   "Yf": function() { return /* binding */ RedBorderButton; }
/* harmony export */ });
/* unused harmony export BorderButton */
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36557);

var BorderButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("button",  true ? {
  target: "e9i6e6l2"
} : 0)("display:flex;width:fit-content;align-items:center;padding:4px 8px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, ";border-radius:4px;gap:4px;transition:all 0.15s ease-in-out;&:hover{cursor:pointer;}&.is-disabled{border:none;background-color:transparent;color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_300;
}, ";}" + ( true ? "" : 0));
var GrayBorderButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BorderButton,  true ? {
  target: "e9i6e6l1"
} : 0)("border:1px solid ", function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.zinc_200;
}, ";color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.zinc_500;
}, ";&:hover{background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.zinc_100;
}, ";}" + ( true ? "" : 0));
var RedBorderButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BorderButton,  true ? {
  target: "e9i6e6l0"
} : 0)("border:1px solid ", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.cerise_100;
}, ";color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.cerise_300;
}, ";&:hover{background-color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.cerise_50;
}, ";}" + ( true ? "" : 0));

/***/ }),

/***/ 62534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pdf_FileRelatedButtons; }
});

// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/jotai/esm/react.mjs
var react = __webpack_require__(752);
// EXTERNAL MODULE: ./state/user/atom.ts
var atom = __webpack_require__(37271);
// EXTERNAL MODULE: ./hooks/useCheckUpdatingFile.tsx
var useCheckUpdatingFile = __webpack_require__(91837);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/User/_components/pdf/FileRelatedButtons/index.styles.ts
var index_styles = __webpack_require__(24430);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/PreviewButton/index.tsx






var PreviewButton = function PreviewButton(_ref) {
  var href = _ref.href,
      isDisabled = _ref.isDisabled,
      handleDisabledButtonClick = _ref.handleDisabledButtonClick;

  var handleOpenPreview = function handleOpenPreview() {
    window.open(href, '_blank', 'noreferrer noopener');
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles/* GrayBorderButton */.QN, {
    className: classnames_default()('', {
      'is-disabled': isDisabled
    }),
    onClick: function onClick(e) {
      e.stopPropagation();

      if (isDisabled) {
        handleDisabledButtonClick(e);
        return;
      }

      handleOpenPreview();
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
      icon: "ph:eye",
      size: 17,
      color: "inherit"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
      variant: "sm-medium",
      color: "inherit",
      children: "\uBBF8\uB9AC\uBCF4\uAE30"
    })]
  });
};

/* harmony default export */ var FileRelatedButtons_PreviewButton = (PreviewButton);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var node_modules_react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(62350);
// EXTERNAL MODULE: ./utils/api.ts + 1 modules
var api = __webpack_require__(74457);
;// CONCATENATED MODULE: ./hooks/mutations/file/useDeleteFile.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var deleteFile = function deleteFile(_ref) {
  var fileId = _ref.fileId;
  return api/* api.delete */.h["delete"]('/file', {
    params: {
      fileId: fileId
    }
  });
};

var useDeleteFile = function useDeleteFile(options) {
  return (0,useMutation/* useMutation */.D)(deleteFile, _objectSpread({}, options));
};

/* harmony default export */ var file_useDeleteFile = (useDeleteFile);
// EXTERNAL MODULE: ./utils/josa.ts
var josa = __webpack_require__(25642);
// EXTERNAL MODULE: ./components/User/_components/common/DeleteConfirmModal/index.tsx + 1 modules
var DeleteConfirmModal = __webpack_require__(41641);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/DeleteButton/DeletePdfFileModal/index.tsx









var DeletePdfFileModal = function DeletePdfFileModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      fileId = _ref.fileId,
      fileName = _ref.fileName;
  var router = (0,next_router.useRouter)();
  var deleteFile = file_useDeleteFile({
    onSuccess: function onSuccess() {
      setIsLoading(false);

      if ('fileId' in router.query && 'clientId' in router.query) {
        router.reload();
        return;
      }

      if ('fileId' in router.query) {
        router.replace('/user/pdf');
      } else {
        router.reload();
      }
    }
  });

  var _useState = (0,node_modules_react.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var handleClickDeleteFile = function handleClickDeleteFile() {
    setIsLoading(true);
    deleteFile.mutate({
      fileId: fileId
    });
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteConfirmModal/* default */.Z, {
    isOpen: isOpen,
    setIsOpen: setIsOpen,
    onClick: handleClickDeleteFile,
    loading: isLoading,
    content: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 10,
      direction: "column",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
        as: "p",
        variant: "xl-semibold",
        children: [(0,josa/* addJosa */.W)(fileName, '을'), " \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Flex */.kC, {
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
          variant: "lg-medium",
          children: ["\uC0AD\uC81C \uC2DC,\xA0", (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Text */.xv, {
            variant: "lg-semibold",
            as: "span",
            children: [fileName, "\uACFC \uC5F0\uACB0\uB41C \uBAA8\uB4E0 \uB9C1\uD06C\uAC00 \uB3D9\uC791\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uADF8\uB798\uB3C4 \uC0AD\uC81C\uD560\uAE4C\uC694?"]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          variant: "lg-medium",
          children: "\uC0AD\uC81C \uD6C4 \uBCF5\uAD6C\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4."
        })]
      })]
    })
  });
};

/* harmony default export */ var DeleteButton_DeletePdfFileModal = (DeletePdfFileModal);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/DeleteButton/index.tsx









var DeleteButton = function DeleteButton(_ref) {
  var fileId = _ref.fileId,
      fileName = _ref.fileName,
      isDisabled = _ref.isDisabled,
      handleDisabledButtonClick = _ref.handleDisabledButtonClick;

  var _useState = (0,node_modules_react.useState)(false),
      isOpenDeleteModal = _useState[0],
      setIsOpenDeleteModal = _useState[1];

  var handleClickDeleteButton = function handleClickDeleteButton(e) {
    if (isDisabled) {
      handleDisabledButtonClick(e);
      return;
    }

    e.stopPropagation();
    setIsOpenDeleteModal(true);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_styles/* RedBorderButton */.Yf, {
      className: classnames_default()('', {
        'is-disabled': isDisabled
      }),
      onClick: handleClickDeleteButton,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:trash",
        size: 17,
        color: "inherit"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
        variant: "sm-medium",
        color: "inherit",
        children: "\uC0AD\uC81C"
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteButton_DeletePdfFileModal, {
      isOpen: isOpenDeleteModal,
      setIsOpen: setIsOpenDeleteModal,
      fileId: fileId,
      fileName: fileName
    })]
  });
};

/* harmony default export */ var FileRelatedButtons_DeleteButton = (DeleteButton);
// EXTERNAL MODULE: ./components/User/_components/pdf/FileRelatedButtons/EditButton/index.tsx + 6 modules
var EditButton = __webpack_require__(17287);
;// CONCATENATED MODULE: ./components/User/_components/pdf/FileRelatedButtons/index.tsx










var FileRelatedButtons = function FileRelatedButtons(_ref) {
  var _userInfo$id, _userInfo$subscriptio, _userInfo$subscriptio2;

  var fileId = _ref.fileId,
      fileName = _ref.fileName,
      fileThumbnail = _ref.fileThumbnail,
      handleHoverSideAction = _ref.handleHoverSideAction;

  var _useCheckUpdatingFile = (0,useCheckUpdatingFile/* default */.Z)(),
      isDisabled = _useCheckUpdatingFile.isDisabled,
      handleDisabledButtonClick = _useCheckUpdatingFile.handleDisabledButtonClick;

  var userInfo = (0,react/* useAtomValue */.Dv)(atom/* userInfoAtom */.w);
  var userId = (_userInfo$id = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) !== null && _userInfo$id !== void 0 ? _userInfo$id : null;
  var userPlan = (_userInfo$subscriptio = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$subscriptio2 = userInfo.subscriptionPlan) === null || _userInfo$subscriptio2 === void 0 ? void 0 : _userInfo$subscriptio2.name) !== null && _userInfo$subscriptio !== void 0 ? _userInfo$subscriptio : 'Free';
  var previewUrl = "/user/pdf-preview?fileId=".concat(fileId, "&userId=").concat(userId);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
    gap: 8,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileRelatedButtons_PreviewButton, {
      href: previewUrl,
      isDisabled: isDisabled,
      handleDisabledButtonClick: handleDisabledButtonClick
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FileRelatedButtons_DeleteButton, {
      fileId: fileId,
      fileName: fileName,
      isDisabled: isDisabled,
      handleDisabledButtonClick: handleDisabledButtonClick
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditButton/* default */.Z, {
      fileId: fileId,
      fileName: fileName,
      fileThumbnail: fileThumbnail,
      userPlan: userPlan,
      isDisabled: isDisabled,
      handleDisabledButtonClick: handleDisabledButtonClick,
      handleHoverSideAction: handleHoverSideAction
    })]
  });
};

/* harmony default export */ var pdf_FileRelatedButtons = (FileRelatedButtons);

/***/ }),

/***/ 91837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61810);
/* harmony import */ var _state_file_uploadingfile_atom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19718);






var useCheckUpdatingFile = function useCheckUpdatingFile() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var fileId = router.query.fileId;
  var toast = (0,_pairy_pds_react__WEBPACK_IMPORTED_MODULE_2__/* .useToast */ .pm)();
  var updatingFileIdList = (0,jotai__WEBPACK_IMPORTED_MODULE_4__/* .useAtomValue */ .Dv)(_state_file_uploadingfile_atom__WEBPACK_IMPORTED_MODULE_3__/* .UploadingFileInfoListAtom */ .bz);
  var isActionDisabledFile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return typeof (updatingFileIdList === null || updatingFileIdList === void 0 ? void 0 : updatingFileIdList.find(function (_ref) {
      var id = _ref.id;
      return Number(id) === Number(fileId);
    })) !== 'undefined';
  }, [fileId, updatingFileIdList]);

  var handleDisabledButtonClick = function handleDisabledButtonClick(e) {
    if (isActionDisabledFile) {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }

      toast.error('파일 수정중에는 불가능합니다');
      return;
    }
  };

  return {
    isDisabled: isActionDisabledFile,
    handleDisabledButtonClick: handleDisabledButtonClick
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useCheckUpdatingFile);

/***/ })

}]);